import { Injectable } from '@angular/core';
import { CustomField } from 'src/app/models/customfield';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandlerService } from '../shared/http-error-handler.service';
import { catchError } from 'rxjs/operators';
import { ForuscareService } from '../foruscare/foruscare.service';
import { Observable } from 'rxjs';
import { find } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FieldCustomizationService {

  private handleError:HandleError;
  constructor(public http:HttpClient,public fourscareService: ForuscareService, public httpErrorHandlerService:HttpErrorHandlerService) {
    this.handleError=httpErrorHandlerService.createHandleError("Field-Customization Service");
   }

  getAllFieldsByAccountIdAndModule(accountId,moduleId,deviceType,serviceProviderId):Observable<any>
  {
    return this.http.get<any>(this.fourscareService.baseAuthURL()+"/customFields/getAllCustomFieldsByModule"+"/"+accountId+"/"+moduleId+"/"+deviceType+"?serviceProviderId="+serviceProviderId)
    .pipe(
      catchError(this.handleError('Error While Fetching Custom Field Data'))
      );
  }

  addOrUpdateCustomFields(accountId,customFieldConfig):Observable<any>
  {
    return this.http.post<any>(this.fourscareService.baseAuthURL()+"/customFields/addOrUpdateCustomFields"+"/"+accountId,customFieldConfig)
    //return this.http.put<any>(this.fourscareService.baseAuthURL()+"/admin/device"+"/0",null)
    .pipe(
      catchError(this.handleError('Error While Updating Custom Field Data'))
    );
  }
  addCustomFields(accountId,fieldCustomizationList):Observable<any>
  {
    return this.http.put<any>(this.fourscareService.baseAuthURL()+"/customFields/addCustomFields"+"/"+accountId,fieldCustomizationList)
    .pipe(
      catchError(this.handleError('Error While Updating Custom Field Data'))
    );
  }

  addConfiguration(accountId,configurationList):Observable<any>
  {
    return this.http.post<any>(this.fourscareService.baseAuthURL()+"/admin/device/addOrUpdateAccountIcdCodes/"+accountId,configurationList)
    .pipe(
      catchError(this.handleError('Error While Updating Custom Field Data'))
    );
  }
  addConfigurationByType(accountId,configurationList,type):Observable<any>
  {
    return this.http.post<any>(this.fourscareService.baseAuthURL()+"/admin/device/addOrUpdateAccountIcdCodesByCategory/"+accountId+"/"+type,configurationList)
    .pipe(
      catchError(this.handleError('Error While Updating Custom Field Data'))
    );
  }
  getDropdownConfigByType(type):Observable<any>
  {
    return this.http.get<any>(this.fourscareService.baseAuthURL()+"/admin/device/getDropdownConfig/"+type)
    .pipe(
      catchError(this.handleError('Error While dropdown config Data'))
    );
  }
  getConfiguration(accountId):Observable<any>
  {
    return this.http.get<any>(this.fourscareService.baseAuthURL()+"/patient/getIcdCodes/"+accountId)
    .pipe(
      catchError(this.handleError('Error While Updating Custom Field Data'))
    );
  }
  getConfigurationByType(accountId,type):Observable<any>
  {
    return this.http.get<any>(this.fourscareService.baseAuthURL()+"/patient/getIcdCodesByCategory/"+accountId+"/"+type)
    .pipe(
      catchError(this.handleError('Error While Updating Custom Field Data'))
    );
  }
  saveRefractionConfig(payload):Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL()+"/refraction/addUpdate/configuration",payload)
    .pipe(
      catchError(this.handleError('Error While saving refraction configuration'))
    );
  }
  isDuplicatePresent(fieldId):Observable<any>
  {
    return this.http.get<any>(this.fourscareService.baseAuthURL()+"/customFields/isDuplicateCustomFieldValuePresent/"+fieldId)
    .pipe(
      catchError(this.handleError('Error While fetching duplicate data'))
    );
  }
}


